// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"58241492c8289478c844","655":"d7b4e9136951d7ba899e"}[chunkId] + ".js";
};